import { useQuery } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dist/clients/dashboard/v99990101'

export const useCreditNoteQuery = (id: string) =>
  useQuery(dashboardv99990101Client.getCreditNote, {
    id
  })
